const moment = require("moment");
require("moment/locale/nb");
import Vue from "vue";
import "./plugins/vuetify";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Clipboard from "v-clipboard";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSplit from "vue-split-panel";
import RouterPrefetch from "vue-router-prefetch";
import "@mdi/font/css/materialdesignicons.css";
import VueCookies from "vue-cookies";
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);
Vue.use(VueCookies);
Vue.use(VueSplit);
Vue.use(require("vue-moment"), {
  moment,
});
Vue.use(RouterPrefetch);
Vue.use(VueAxios, axios);
Vue.use(Clipboard);
Vue.use(Vuetify);

Vue.prototype.$eventHub = new Vue();
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
